import { AgreementInfo } from "../../../api/services";
import { isBefore, addDays, isAfter } from "date-fns";

// Sort agreements by date in descending order
export const compareAgreement = (a: AgreementInfo, b: AgreementInfo) => {
  if (a === b) {
    return 0;
  }
  if (a.toDttm !== b.toDttm) {
    if (a.toDttm == null) {
      return -1;
    }
    if (b.toDttm == null) {
      return 1;
    }
    return b.toDttm.localeCompare(a.toDttm);
  }
  if (a.fromDttm === b.fromDttm) {
    return b.id.localeCompare(a.id);
  }
  return b.fromDttm.localeCompare(a.fromDttm);
};

export const createAgreementHistory = (agreements: AgreementInfo[]) => {
  const today = new Date().setUTCHours(0, 0, 0, 0);

  const { future, past, current } = agreements.reduce<{
    future: AgreementInfo[];
    past: AgreementInfo[];
    current: AgreementInfo[];
  }>(
    (agreementGroups, agreement) => {
      const { fromDttm, cancelledDttm, toDttm } = agreement;
      if (
        cancelledDttm != null ||
        (toDttm != null && isBefore(new Date(toDttm), addDays(today, 1)))
      ) {
        agreementGroups.past.push(agreement);
      } else if (isAfter(new Date(fromDttm), today)) {
        agreementGroups.future.push(agreement);
      } else {
        agreementGroups.current.push(agreement);
      }
      return agreementGroups;
    },
    {
      future: [],
      past: [],
      current: [],
    },
  );
  return {
    future: future.sort(compareAgreement),
    past: past.sort(compareAgreement),
    current: current.sort(compareAgreement),
  };
};
